import React from 'react';
// import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {translate} from 'views/module';

import TourGuide from './TourGuide';

import Joyride from 'react-joyride';

const Guide = (props) => {
  const [runTour, setRunTour] = React.useState(() => {
    const completed = localStorage.getItem('tourComplete');
    return completed !== 'true';
  });

  const joyrideSteps = [
    {
      target: '#chat-window',
      title: translate('profile.TourGuide.TitleStep1'),
      description: translate('profile.TourGuide.TextStep1'),
      disableBeacon: true,
      placement: 'auto',
    },
    {
      target: '#form-preview',
      title: translate('profile.TourGuide.TitleStep2'),
      description: translate('profile.TourGuide.TextStep2'),
      placement: 'auto',
    },
    {
      target: '#form-edit-btn',
      title: translate('profile.TourGuide.TitleStep3'),
      description: translate('profile.TourGuide.TextStep3'),
    },
    {
      target: 'body',
      title: translate('profile.TourGuide.TitleStep4'),
      description: translate('profile.TourGuide.TextStep4'),
      placement: 'center',
    },
  ];

  return (
    <>
      <Joyride
        steps={joyrideSteps}
        run={runTour}
        continuous
        showSkipButton
        disableBeacon
        disableOverlayClose
        disableCloseOnEsc
        tooltipComponent={(data) => (
          <TourGuide
            stepIndex={data.index}
            title={data.step.title}
            description={data.step.description}
            onNext={data.primaryProps.onClick}
            onSkip={data.skipProps.onClick}
            mobile={false}
          />
        )}
        styles={{
          options: {
            zIndex: 10000,
          },
        }}
        callback={async (data) => {
          if (data.status === 'finished' || data.status === 'skipped') {
            localStorage.setItem('tourComplete', 'true');
            setRunTour(false);
          }
        }}
      />
    </>
  );
};

Guide.propTypes = {
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Guide));
